<template>
  <div class="section-scroll section-view section-offset-bottom">
    <div class="section-view-title section-view-title--with-link">
      <div class="section-view-title-content section-view-title-content--flex">
        Отзывы наших клиентов
        <div class="rr-products-arrows">
          <div class="rr-products-arrow" @click="setPage(-1)">
            <svg viewBox="0 0 22 38" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.9706 2.02944L3 19L19.9705 35.9706" stroke-width="4" stroke-linecap="round"></path>
            </svg>
          </div>
          <div class="rr-products-arrow" @click="setPage(1)">
            <svg viewBox="0 0 23 38" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.63881 2.02944L19.6094 19L2.63885 35.9706" stroke-width="4" stroke-linecap="round"></path>
            </svg>
          </div>
        </div>
      </div>
      <a href="/reviews" class="btn-main btn-big">
        <span class="btn-main-overlay">
          <span class="btn-main-content">
            Читать все отзывы
          </span>
        </span>
        <span class="btn-main-shadow"></span>
      </a>
    </div>
    <div class="reviews-slider">
      <div class="reviews-slide" v-for="item in list">
        <div class="review-teaser">
          <div class="review-teaser-header">
            <div class="review-teaser-name">
              {{ item.userName }}
            </div>
            <div class="review-teaser-date">
              {{ item.created }}
            </div>
            <div class="review-teaser-city">
              {{ item.city }}
            </div>
          </div>
          <div
            class="review-teaser-body"
            :class="{'review-teaser-body--cropped': item.text.length > textLimit}"
            v-html="item.text.slice(0, textLimit)"
          ></div>
          <div class="review-teaser-footer" v-if="item.text.length > textLimit || item.isImages">
            <a :href="'/node/' + item.id" class="review-teaser-link" target="_blank">
              Читать полностью
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FrontReviews',
  data() {
    return {
      page: 0,
      pages: 0,
      limit: 4,
      textLimit: 240,
      list: []
    }
  },
  methods: {
    getList() {
      axios.get('/reviews/get-frontpage-list', {
        params: { page: this.page, limit: this.limit }
      }).then((response) => {
        this.list = response.data.list || []
        this.pages = response.data.pages
      })
    },
    setPage(dir) {
      if (this.page === 0 && dir === -1) {
        this.page = this.pages - 1
      }
      else if (this.page + 1 === this.pages) {
        this.page = 0
      }
      else {
        this.page += dir
      }

      this.getList()
    },
  },
  created() {
    if (window.innerWidth < 642) {
      this.limit = 1
    }
    else if (window.innerWidth < 1025) {
      this.limit = 2
    }
    else if (window.innerWidth < 1500) {
      this.limit = 3
    }

    this.getList()
  }
}
</script>